import { observer } from "mobx-react-lite";
import ProjectDetail from "../../components/financier/projects/ProjectDetail";
import FinancierSharedView from "../shared/FinancierSharedView";

export default observer(function ProjectDetailPage() {
  return <FinancierSharedView mainContent={<ProjectDetail />} />;
});
